import moment from "moment-timezone";
import { weekdays } from "../../../../components/shared/inputs/WeekdaySelect/types";

export const getOrderedWeekdays = () => {
    const firstDay = moment.localeData().firstDayOfWeek();
    return [...weekdays.slice(firstDay), ...weekdays.slice(0, firstDay)];
}
